export enum UNDOABLE_TYPE {
	NONE, PROJECT_FLOWCHART, TIMELINE_DATA
}
